import React, {useRef, useState} from 'react'
import {gql, useLazyQuery} from '@apollo/client'
import useEffect from 'admin/hooks/useEffect'
import List from './List'

const QUERY = gql`
  query GetAccountsForAccountField($search: String) {
    accounts(q: $search, limit: 5, state: "active") {
      collection {
        id
        displayName @client
        name
        contactFirstName
        contactLastName
        contactAddress
        contactEmail
        customerNumber
      }
    }
  }
`

export default ({
  organisationID: organisationId,
  value,
  label,
  className,
  onChange,
  onSelect,
  exclude = [],
  errors,
  ...props
}) => {
  const ref = useRef()
  const [showList, setShowList] = useState(false)
  const [search, setSearch] = useState(value)

  useEffect(() => setSearch(value), [value], false)

  useEffect(() => {
    const handleExit = ({target: clickedElement}) => {
      if (ref.current && !ref.current.contains(clickedElement)) {
        setShowList(false)
      }
    }

    document.addEventListener('click', handleExit)
    return () => document.removeEventListener('click', handleExit)
  }, [])

  const [getAccounts, {data: {accounts = {}} = {}}] = useLazyQuery(QUERY)

  const handleSearch = search => {
    setSearch(search)
    if (search && search.length) {
      getAccounts({variables: {organisationId, search}})
      setShowList(true)
    } else {
      setShowList(false)
      if (!search.length) onSelect({id: null})
    }
  }

  const handleSelection = account => {
    onSelect && onSelect({...account, name: account.displayName})
    setSearch(null)
    setShowList(false)
  }

  const data = accounts.collection ? accounts.collection.filter(({id}) => !exclude.includes(id)) : []

  return (
    <div style={{width: '100%'}} className={`dropdown ${showList ? 'is-active' : ''}`}>
      <div style={{width: '100%'}} className='dropdown-trigger'>
        {label && (
          <label htmlFor={props.id || 'accountName'} className='label is-small'>
            {label}
          </label>
        )}
        <input
          id='accountName'
          {...props}
          ref={ref}
          type='text'
          name='search'
          autoComplete='off'
          value={search || ''}
          aria-controls='accounts-list'
          aria-haspopup='true'
          onChange={e => {
            e.preventDefault()
            handleSearch(e.target.value)
          }}
          className={`input ${errors ? 'is-danger' : ''} ${className || ''} ${props.readOnly ? 'is-static' : ''}`}
        />
        {errors && <span className={`help ${errors ? 'is-danger' : ''}`}>{errors.join(', ')}</span>}
      </div>
      <div className='dropdown-menu' id='accounts-list' role='menu'>
        <List ref={ref} accounts={data} onClick={handleSelection} organisationId={organisationId} />
      </div>
    </div>
  )
}
